import COLORS from '@/constants/colors';
import { formatDayJsDate } from '@/utils/dateTime';
import { Box, Paper, Stack, Typography } from '@mui/material';
import { SellerLineUi } from '../CartUiModel';

export const SellerTicket = (props: { sellerTicketUi: SellerLineUi }) => {
  const subtitleStyle = {
    fontWeight: 500,
    color: COLORS.gray_800,
    fontSize: '12px',
  };

  return (
    <Paper
      key={props.sellerTicketUi.id}
      sx={{ display: 'flex', flexDirection: 'column', boxShadow: 'none' }}
    >
      <Box
        style={{
          lineHeight: '1.5',
          color: COLORS.gray_800,
          fontSize: '12px',
          fontWeight: 700,
          marginBottom: '12px',
        }}
      >
        {props.sellerTicketUi.name}
      </Box>

      <Typography variant="body1" sx={subtitleStyle}>
        Mínimo de compra: ${props.sellerTicketUi.minimumOrderAmount}
      </Typography>

      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'space-between',
          marginTop: '16px',
        }}
      >
        <Typography variant="body1" sx={subtitleStyle}>
          Total de vendedor
        </Typography>
        <Typography
          variant="body1"
          sx={{
            fontWeight: 500,
            color: COLORS.gray_800,
            fontSize: '12px',
          }}
        >
          ${props.sellerTicketUi.total}
        </Typography>
      </Box>
      <Stack sx={{ mt: '16px' }} spacing={'12px'}>
        <Stack direction={'row'} spacing={'12px'}>
          <Stack flexGrow={1}>
            <Typography variant="body1" sx={subtitleStyle}>
              Fecha de entrega
            </Typography>
            <span>
              {props.sellerTicketUi.deliveryDate &&
                formatDayJsDate(props.sellerTicketUi.deliveryDate)}
            </span>
          </Stack>
          <Stack flexGrow={1}>
            <Typography variant="body1" sx={subtitleStyle}>
              Hora mínima de entrega
            </Typography>
            <span>
              {props.sellerTicketUi.deliveryStartTime?.format('HH:mm')}
            </span>
          </Stack>
          <Stack flexGrow={1}>
            <Typography variant="body1" sx={subtitleStyle}>
              Hora máxima de entrega
            </Typography>
            <span>{props.sellerTicketUi.deliveryEndTime?.format('HH:mm')}</span>
          </Stack>
        </Stack>
        <Stack>
          <Typography variant="body1" sx={subtitleStyle}>
            Notas de entrega
          </Typography>
          <span>{props.sellerTicketUi.deliveryNotes}</span>
        </Stack>
      </Stack>
    </Paper>
  );
};
